<div *ngIf="loader" class="loaderContainer">
    <mat-spinner color="accent" diameter="30"></mat-spinner>
</div>

  
  
  
  <fury-page-layout [style.display]="!loader ? 'block' : 'none'">

    <fury-page-layout-header>
      <fury-breadcrumbs [crumbs]="['Lead']" current="Lead details"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content class="padding-0">
      <div class="button_section">
        <button (click)="changeParams('customerInformation')" [ngClass]="phoneError || emailError ? 'errorTab' : paramName === 'customerInformation' ? 'active' : ''">
          Customer Information
        </button>
        <button (click)="changeParams('propertyInformation')" [ngClass]="{'active': paramName === 'propertyInformation'}">
          Property Information
        </button>
        <button (click)="changeParams('coverageInformation')" [ngClass]="{'active': paramName === 'coverageInformation'}">Coverage Information</button>
        <button (click)="changeParams('paymentInformation')" [ngClass]="{'active': paramName === 'paymentInformation'}">
          Payment Information
        </button>
        <button (click)="changeParams('notes')" [ngClass]="{'active': paramName === 'notes'}">Notes</button>
        <button (click)="changeParams('relatedPolicies')" [ngClass]="{'active': paramName === 'relatedPolicies'}">Related Policies</button>
        <button (click)="changeParams('relatedLeads')" [ngClass]="{'active': paramName === 'relatedLeads'}">Related Leads</button>
        <button (click)="changeParams('source')" [ngClass]="{'active': paramName === 'source'}">Source</button>
        <button (click)="changeParams('security')" [ngClass]="proxyError || realyError || torError || vpnError || ipAddress ? 'errorTab' : paramName === 'security' ? 'active' : ''">Security</button>
        <button (click)="changeParams('flags')" [ngClass]="{'active': paramName === 'flags'}">Flags</button>
      </div>

      <div>
        <div *ngIf="paramName == 'customerInformation'">
          <fury-card [@fadeInUp]>
              <fury-card-content>
              <form [formGroup]="customerInformationForm">

                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input matInput placeholder="First Name" formControlName="firstName" (keyup)="apiservice.restrictSpace($event)" (keypress)="apiservice.restrictSpecialChar($event)">
                      <mat-error
                        *ngIf="customerInformationForm.controls['firstName'].touched && customerInformationForm.controls['firstName'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error *ngIf="
                          customerInformationForm.controls['firstName'].touched &&
                          customerInformationForm.controls['firstName'].hasError('minlength')">
                        Please enter a valid first name.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput placeholder="Last Name" formControlName="lastName" (keyup)="apiservice.restrictSpace($event)" (keypress)="apiservice.restrictSpecialChar($event)">
                      <mat-error
                        *ngIf="customerInformationForm.controls['lastName'].touched && customerInformationForm.controls['lastName'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error *ngIf="
                          customerInformationForm.controls['lastName'].touched &&
                          customerInformationForm.controls['lastName'].hasError('minlength')">
                        Please enter a valid last name.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline" [ngClass]="{'errorField': phoneError}">
                      <mat-label>Mobile Number</mat-label>
                      <input matInput placeholder="Mobile Number" formControlName="mobileNumber" mask="(000) 000-0000">
                      <mat-error
                        *ngIf="customerInformationForm.controls['mobileNumber'].touched && customerInformationForm.controls['mobileNumber'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error *ngIf="
                        customerInformationForm.controls['mobileNumber'].touched &&
                        !customerInformationForm.controls['mobileNumber'].hasError('required') &&
                        customerInformationForm.controls['mobileNumber'].hasError('pattern')
                      ">
                          Enter a correct phone number
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Home Number</mat-label>
                      <input matInput type="text" placeholder="Home Number" formControlName="homeNumber" mask="(000) 000-0000">
                      <mat-error
                        *ngIf="customerInformationForm.controls['homeNumber'].touched && customerInformationForm.controls['homeNumber'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error *ngIf="
                            customerInformationForm.controls['homeNumber'].touched &&
                            !customerInformationForm.controls['homeNumber'].hasError('required') &&
                            customerInformationForm.controls['homeNumber'].hasError('pattern')
                          ">
                              Enter a correct Home number
                            </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Secondary Mobile Number</mat-label>
                      <input matInput placeholder="Secondary Mobile Number" formControlName="secondaryMobileNumber" mask="(000) 000-0000">
                        <mat-error *ngIf="
                        customerInformationForm.controls['secondaryMobileNumber'].touched &&
                        !customerInformationForm.controls['secondaryMobileNumber'].hasError('required') &&
                        customerInformationForm.controls['secondaryMobileNumber'].hasError('pattern')
                      ">
                          Enter a correct secondary phone number.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline" [ngClass]="{'errorField': emailError}">
                      <mat-label>Email Address</mat-label>
                      <input matInput placeholder="Email Address" formControlName="emailAddress">
                      <mat-error
                        *ngIf="customerInformationForm.controls['emailAddress'].touched && customerInformationForm.controls['emailAddress'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error *ngIf="
                        customerInformationForm.controls['emailAddress'].touched &&
                        !customerInformationForm.controls['emailAddress'].hasError('required') &&
                        customerInformationForm.controls['emailAddress'].hasError('pattern')
                      ">
                          Enter a valid email address.
                        </mat-error>
                    </mat-form-field>
                  </div>

                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Secondary Email Address</mat-label>
                    <input matInput placeholder="Secondary Email Address" formControlName="secondaryEmailAddress">
                      <mat-error *ngIf="
                      customerInformationForm.controls['secondaryEmailAddress'].touched &&
                      !customerInformationForm.controls['secondaryEmailAddress'].hasError('required') &&
                      customerInformationForm.controls['secondaryEmailAddress'].hasError('pattern')
                    ">
                        Enter a valid secondary email address.
                      </mat-error>
                  </mat-form-field>
                </div>

                <div class="actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          
                  <button mat-button type="button" class="sub-button" (click)="submitCustomerInformation()">SAVE</button>
                 
                </div>

                  
              </form>
              </fury-card-content>
            </fury-card>
        </div>
        <div [style.display]="paramName == 'propertyInformation' ? 'block' : 'none'">
          <fury-card [@fadeInUp]>
            <fury-card-content>
              <form [formGroup]="propertyInfoForm">

                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Select Property Type</mat-label>
                      <mat-select formControlName="propertyTypeId">
                        <mat-option *ngFor="let item of propertyTypeList" [value]="item.planPropertyTypeId
                        " > {{item?.title}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="propertyInfoForm.get('propertyTypeId')?.touched && propertyInfoForm.get('propertyTypeId')?.hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Select Property Size</mat-label>
                      <mat-select formControlName="propertySizeId">
                        <mat-option *ngFor="let item of propertySizeList" [value]="item.planPropertySizeId
                        " > {{item?.title}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="propertyInfoForm.get('propertySizeId')?.touched && propertyInfoForm.get('propertySizeId')?.hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Property Value</mat-label>
                    <input matInput type="number" placeholder="Property Value" formControlName="propertyValue">
                    <mat-error
                      *ngIf="propertyInfoForm.controls['propertyValue'].touched && propertyInfoForm.controls['propertyValue'].hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>

                  <ng-container formGroupName="propertyAddress">
                    <h2>Coverage Property information</h2>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Property Unit Number</mat-label>
                        <input matInput type="number" placeholder="Property Unit Number" formControlName="unitNumber">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'propertyAddress.unitNumber'
                        )!.valid &&
                        propertyInfoForm.get(
                          'propertyAddress.unitNumber'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Property Address</mat-label>
                        <input #prpoertyLocation matInput placeholder="Property Address" formControlName="streetAddress">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'propertyAddress.streetAddress'
                        )!.valid &&
                        propertyInfoForm.get(
                          'propertyAddress.streetAddress'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Property State</mat-label>
                        <input matInput placeholder="Property State" formControlName="state">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'propertyAddress.state'
                        )!.valid &&
                        propertyInfoForm.get(
                          'propertyAddress.state'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Property City</mat-label>
                        <input matInput placeholder="Property City" formControlName="city">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'propertyAddress.city'
                        )!.valid &&
                        propertyInfoForm.get(
                          'propertyAddress.city'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>

                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Property Zip</mat-label>
                      <input matInput placeholder="Property Zip" formControlName="zip">
                      <mat-error *ngIf="
                      !propertyInfoForm.get(
                        'propertyAddress.zip'
                      )!.valid &&
                      propertyInfoForm.get(
                        'propertyAddress.zip'
                      )!.touched
                    ">
                    This field is required.
                  </mat-error>
                    </mat-form-field>
                  </ng-container>

                  <!-- for Billing Address -->
                  <ng-container formGroupName="billingAddress">
                    <h2>Billing information</h2>
                    <div>
                      <input type="checkbox" formControlName="sameAsPropertyAddress"> <span style="margin-left:10px; dislplay:block;">Same as property Address</span>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Biling Unit Number</mat-label>
                        <input matInput type="number" placeholder="Property Unit Number" formControlName="unitNumber">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'billingAddress.unitNumber'
                        )!.valid &&
                        propertyInfoForm.get(
                          'billingAddress.unitNumber'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Billing Address</mat-label>
                        <input #billingLocation matInput placeholder="Billing Address" formControlName="streetAddress">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'billingAddress.streetAddress'
                        )!.valid &&
                        propertyInfoForm.get(
                          'billingAddress.streetAddress'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Billing State</mat-label>
                        <input matInput placeholder="Billing State" formControlName="state">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'billingAddress.state'
                        )!.valid &&
                        propertyInfoForm.get(
                          'billingAddress.state'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Billing City</mat-label>
                        <input matInput placeholder="Billing City" formControlName="city">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'billingAddress.city'
                        )!.valid &&
                        propertyInfoForm.get(
                          'billingAddress.city'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Billing Zip</mat-label>
                        <input matInput placeholder="Billing Zip" formControlName="zip">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'billingAddress.zip'
                        )!.valid &&
                        propertyInfoForm.get(
                          'billingAddress.zip'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                  </ng-container>

                  <!-- For Mailing address -->
                  <ng-container formGroupName="mailingAddress">
                    <h2>Mailing information</h2>
                    <div>
                      <input type="checkbox" formControlName="sameAsPropertyAddress"> <span style="margin-left:10px; dislplay:block;">Same as property Address</span>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Mailing Unit Number</mat-label>
                        <input type="number" matInput placeholder="Mailing Unit Number" formControlName="unitNumber">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'mailingAddress.unitNumber'
                        )!.valid &&
                        propertyInfoForm.get(
                          'mailingAddress.unitNumber'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Mailing Address</mat-label>
                        <input #mailingAddress matInput placeholder="Mailing Address" formControlName="streetAddress">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'mailingAddress.streetAddress'
                        )!.valid &&
                        propertyInfoForm.get(
                          'mailingAddress.streetAddress'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Mailing State</mat-label>
                        <input matInput placeholder="Mailing State" formControlName="state">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'mailingAddress.state'
                        )!.valid &&
                        propertyInfoForm.get(
                          'mailingAddress.state'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>

                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Mailing City</mat-label>
                        <input matInput placeholder="Mailing City" formControlName="city">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'mailingAddress.city'
                        )!.valid &&
                        propertyInfoForm.get(
                          'mailingAddress.city'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Mailing Zip</mat-label>
                        <input matInput placeholder="Mailing Zip" formControlName="zip">
                        <mat-error *ngIf="
                        !propertyInfoForm.get(
                          'mailingAddress.zip'
                        )!.valid &&
                        propertyInfoForm.get(
                          'mailingAddress.zip'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </div>
                    
                <div class="actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          
                  <button mat-button type="button" class="sub-button" (click)="submitPropertyInfoForm()">SAVE</button>
                 
                </div>
             
              
              </form>
            </fury-card-content>
          </fury-card>
          
        </div>
        <div *ngIf="paramName == 'notes'" class="notesarea">
         
          <table width="100%" cellpadding="0" cellspacing="0" border="1" class="table">
            <thead>
              <tr *ngIf="noteLists">
                <th align="left">Notes</th>
                <th align="left">Created By</th>
                <th align="left">Added On</th>
                <th align="left">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of noteLists">
                <td> {{item?.note}} </td>
                <td>{{item?.createdBy?.firstName + " " + item?.createdBy?.lastName}}</td>
                <td>{{item?.timeStamp | date:'medium'}}</td>
                <td class="statusprt"> 
                  <span *ngIf="isDateBetween24Hours(item?.timeStamp)" (click)="openDialog(item)" style="cursor: pointer;"><mat-icon>edit</mat-icon></span> 
                  <span (click)="deleteNote(item?.noteId)" style="cursor: pointer;"><mat-icon>delete</mat-icon></span>
                </td>
              </tr>
              <tr *ngIf="noteLists?.length == 0">
                <td colspan="4" align="center">
                  <p>No notes found</p>
                </td>
              </tr>
            </tbody>
            
          </table>
          <!-- <div *ngIf="noteLists?.length == 0">
            <p>No notes found</p>
          </div> -->

          <!-- <div class="form-fld text-center">
            <div class="actionControl">
              <button type="button" class="submit-btn" (click)="openCreateNotesModal()"><span>Create Notes</span></button>
            </div>
          </div> -->

          <div class="actions" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="openCreateNotesModal()">Create Notes</button>
           
          </div>
        </div>
        <div *ngIf="paramName == 'coverageInformation'">
          <fury-card [@fadeInUp]>
            <fury-card-content>
              <form [formGroup]="coverageInfoForm" style="width: 100%; flex-direction:column;">
                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Select Plan</mat-label>
                      <mat-select formControlName="planId" >
                        <mat-option *ngFor="let item of planList" [value]="item?.planOptionalItemCategoryId
                        " > {{item?.title}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="coverageInfoForm.get('planId')?.touched && coverageInfoForm.get('planId')?.hasError('required')">
                        This is a required field.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Optional Plan Items</mat-label>
                      <mat-select formControlName="optionalPlanItems" multiple>
                        <mat-option *ngFor="let item of coverItemList" [value]="item?.planCoverItemId">{{item?.title}}</mat-option>
                      </mat-select>
                     
                      <mat-error
                        *ngIf="coverageInfoForm.controls['coverageTerm'].touched && coverageInfoForm.controls['coverageTerm'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Coverage Term</mat-label>
                      <mat-select formControlName="coverageTerm">
                        <mat-option value="Monthly">Monthly</mat-option>
                        <mat-option value="Yearly">Yearly</mat-option>
                        <mat-option value="3 Years">3 Years</mat-option>
                      </mat-select>
                      
                      <mat-error
                        *ngIf="coverageInfoForm.controls['coverageTerm'].touched && coverageInfoForm.controls['coverageTerm'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Free Month</mat-label>
                      <input type="number" matInput placeholder="Free Month" formControlName="freeMonth" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['freeMonth'].touched && coverageInfoForm.controls['freeMonth'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Co Payment Fee</mat-label>
                      <input type="number" matInput placeholder="Co Payment Fee" formControlName="coPaymentFee" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['coPaymentFee']?.touched && coverageInfoForm.controls['coPaymentFee'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Plan Cost</mat-label>
                      <input type="number" matInput placeholder="Plan Cost" formControlName="planCost" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['planCost'].touched && coverageInfoForm.controls['planCost'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Additional Price</mat-label>
                      <input type="number" matInput placeholder="Additional Price" formControlName="additionalPrice" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['additionalPrice']?.touched && coverageInfoForm.controls['additionalPrice'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Discount</mat-label>
                      <input type="number" matInput placeholder="Discount" formControlName="discount" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['discount'].touched && coverageInfoForm.controls['discount'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Surcharge</mat-label>
                      <input type="number" matInput placeholder="Surcharge" formControlName="surcharge" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['surcharge'].touched && coverageInfoForm.controls['surcharge'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Total Cost</mat-label>
                      <input type="number" matInput placeholder="Total Cost" formControlName="totalCost" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['totalCost'].touched && coverageInfoForm.controls['totalCost'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Sub Total</mat-label>
                      <input type="number" matInput placeholder="Sub Total" formControlName="downPaymentAmount" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['downPaymentAmount'].touched && coverageInfoForm.controls['downPaymentAmount'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Monthly Payment</mat-label>
                      <input type="number" matInput placeholder="Monthly Payment" formControlName="monthlyPayment">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['monthlyPayment'].touched && coverageInfoForm.controls['monthlyPayment'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>

                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Agreement Number</mat-label>
                      <input type="number" matInput placeholder="Agreement Number" formControlName="agreementNumber" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['agreementNumber'].touched && coverageInfoForm.controls['agreementNumber'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Waiting Period</mat-label>
                      <input type="number" matInput placeholder="Waiting Period" formControlName="waitingPeriod" min="0">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['waitingPeriod'].touched && coverageInfoForm.controls['waitingPeriod'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Agreement Effective Date</mat-label>
                      <input matInput type="date" formControlName="agreementEffectiveDate">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['agreementEffectiveDate'].touched && coverageInfoForm.controls['agreementEffectiveDate'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Agreement Expire Date</mat-label>
                      <input matInput type="date" formControlName="agreementExpireDate">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['agreementExpireDate'].touched && coverageInfoForm.controls['agreementExpireDate'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Agreement Purchase Date</mat-label>
                      <input matInput type="date" formControlName="agreementPurchaseDate">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['agreementPurchaseDate'].touched && coverageInfoForm.controls['agreementPurchaseDate'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <!-- <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Remaining Amount</mat-label>
                      <input matInput type="number" placeholder="Remaining Amount" formControlName="remainingAmount">
                      <mat-error
                        *ngIf="coverageInfoForm.controls['remainingAmount'].touched && coverageInfoForm.controls['remainingAmount'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field> -->
                  </div>
                </div>

                <div class="actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          
                  <!-- <button mat-button type="button" class="sub-button" (click)="submitCoverageInfoForm()">SAVE</button> -->
                 
                </div>
               

              </form>
            </fury-card-content>
          </fury-card>
        
        </div>
        <div *ngIf="paramName == 'relatedPolicies'">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" width="100%">         
            <!-- agreement Number -->
            <ng-container matColumnDef="agreementNumber">
              <th mat-header-cell *matHeaderCellDef> Agreement Number </th>
              <td mat-cell *matCellDef="let element"> {{element.agreementNumber}} </td>
            </ng-container>
          
            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef> First Name </th>
              <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
            </ng-container>
          
            <!-- Last Name Column -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef> Last Name </th>
              <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
            </ng-container>
          
            <!-- Total ammount Column -->
            <ng-container matColumnDef="total_amount">
              <th mat-header-cell *matHeaderCellDef> Total Ammount </th>
              <td mat-cell *matCellDef="let element"> {{element.total_amount}} </td>
            </ng-container>
            <!-- Agreement Start Data -->
            <ng-container matColumnDef="agreementStartDate">
              <th mat-header-cell *matHeaderCellDef> Agreement Start Date </th>
              <td mat-cell *matCellDef="let element"> {{element.agreementStartDate | date}} </td>
            </ng-container>
            <!-- Action column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let element">
                <span [routerLink]="['/customer-agreement/customer-detail', element?.agreementNumber]" style="cursor:pointer;"><mat-icon>visibility</mat-icon></span> 
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="dataSource?.length === 0" style="padding: 10px 0; text-align:center;">
            No Policies found.
        </div>
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig] = "selectConfig"
          [ngClass]="{'mat-pegig': pageSize === 9999}"
          aria-label="Select page of periodic elements">
      </mat-paginator>
          

        </div>
        <div *ngIf="paramName == 'relatedLeads'">
          <table mat-table [dataSource]="relatedLeadDataSource" class="mat-elevation-z8" width="100%">

          
            <!-- First name -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef> First Name </th>
              <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
            </ng-container>
          
            <!--Last Name -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef> Last Name </th>
              <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
            </ng-container>
          
            <!-- Email -->
            <ng-container matColumnDef="emailAddress">
              <th mat-header-cell *matHeaderCellDef> Email ID </th>
              <td mat-cell *matCellDef="let element"> {{element.emailAddress}} </td>
            </ng-container>
            <!-- attempts -->
            <ng-container matColumnDef="attempts">
              <th mat-header-cell *matHeaderCellDef> Attempts </th>
              <td mat-cell *matCellDef="let element"> {{element.attempts || 0}} </td>
            </ng-container>
            <!-- address -->
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef> Address </th>
              <td mat-cell *matCellDef="let element"> {{element.address?.streetAddress}} </td>
            </ng-container>
            <!-- city -->
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef> City </th>
              <td mat-cell *matCellDef="let element"> {{element.address?.city}} </td>
            </ng-container>
            <!-- zip -->
            <ng-container matColumnDef="zip">
              <th mat-header-cell *matHeaderCellDef> Zip </th>
              <td mat-cell *matCellDef="let element"> {{element.address?.zip}} </td>
            </ng-container>
            <!-- action -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let element"> 
                <span (click)="navigateLeadDetailsPage(element?.leadId)" style="cursor:pointer;">
                  <mat-icon>visibility</mat-icon>
                </span>
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="reletedLeadDisplayColumn"></tr>
            <tr mat-row *matRowDef="let row; columns: reletedLeadDisplayColumn;"></tr>
          </table>
          <div *ngIf="relatedLeadDataSource?.length === 0" style="padding: 10px 0; text-align:center;">
            No Leads found.
        </div>
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="leadPageSize" [length]="leadTotalCount" [pageIndex]="leadPageIndex" (page)="leadPageSizeChange($event)"
          showFirstLastButtons
          [selectConfig] = "selectConfig"
          [ngClass]="{'mat-pegig': pageSize === 9999}"
          aria-label="Select page of periodic elements">
      </mat-paginator>
       
        </div>
        <div *ngIf="paramName == 'source'">
          <fury-card [@fadeInUp]>
            <fury-card-content>
              <form [formGroup]="sourceForm" style="width: 100%;   flex-direction:column;">
                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Lead Number</mat-label>
                      <input matInput placeholder="Lead Number" formControlName="leadNumber">
                      <mat-error
                        *ngIf="sourceForm.controls['leadNumber'].touched && sourceForm.controls['leadNumber'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Lead Source</mat-label>
                      <input matInput placeholder="Lead Source" formControlName="leadSource" type="text"  >
                      <mat-error
                        *ngIf="sourceForm.controls['leadSource'].touched && sourceForm.controls['leadSource'].hasError('required')">
                        This is a required field.</mat-error>
                        <mat-error
                  *ngIf="sourceForm.controls['leadSource'].touched && sourceForm.controls['leadSource'].errors">
                  Max length should be 3.</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field fxFlex="auto" appearance="outline">
                      <mat-label>Lead Cost</mat-label>
                      <input matInput type="number" placeholder="Lead Cost" formControlName="leadCost">
                      <mat-error
                        *ngIf="sourceForm.controls['leadCost'].touched && sourceForm.controls['leadCost'].hasError('required')">
                        This is a required field.</mat-error>
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>External Id</mat-label>
                      <input matInput placeholder="External Id" formControlName="externalId">
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Sub Id</mat-label>
                      <input matInput placeholder="Sub Id" formControlName="subId" >
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Click Id</mat-label>
                      <input matInput placeholder="Click Id" formControlName="clickId" readonly>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Traffic</mat-label>
                      <input matInput placeholder="Traffic" formControlName="traffic" readonly>
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Position</mat-label>
                      <input matInput placeholder="Position" formControlName="position" readonly>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Ref Keyword</mat-label>
                      <input matInput placeholder="Ref Keyword" formControlName="refKeyword" readonly>
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Referral Website</mat-label>
                      <input matInput placeholder="Referral Website" formControlName="referralWebsite" readonly>
                      <mat-error *ngIf="
                            sourceForm.controls['referralWebsite'].touched &&
                            !sourceForm.controls['referralWebsite'].hasError('required') &&
                            sourceForm.controls['referralWebsite'].hasError('pattern')
                          ">
                              Please Enter Valid Url.
                            </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Internal Url</mat-label>
                      <input matInput placeholder="Internal Url" formControlName="internalUrl" readonly>
                      <mat-error *ngIf="
                            sourceForm.controls['internalUrl'].touched &&
                            !sourceForm.controls['internalUrl'].hasError('required') &&
                            sourceForm.controls['internalUrl'].hasError('pattern')
                          ">
                              Please Enter Valid Url.
                            </mat-error>
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Gcl Id</mat-label>
                      <input matInput placeholder="Gcl Id" formControlName="gclid" readonly>
                    </mat-form-field>
                  </div>
                </div>
               
                <div class="actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  
                  <button mat-button type="button" class="sub-button" (click)="submitSourceForm()">SAVE</button>
                 
                </div>
            
              </form>
            </fury-card-content>
          </fury-card>
          
        </div>
        <div *ngIf="paramName == 'security'">
          <fury-card [@fadeInUp]>
            <fury-card-content>
              <form [formGroup]="securityForm" style="width: 100%;   flex-direction:column;">
                <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <mat-form-field class="disabled" [ngClass]="{'errorField': ipAddress}"  fxFlex="auto" appearance="outline">
                    <mat-label>Ip Address</mat-label>
                    <input matInput readonly="true" placeholder="Ip Address" formControlName="ipAddress">
                  </mat-form-field>
                </div>
                <div style="border:1px solid #ccc; padding:20px; border-radius: 10px; margin-bottom: 20px;">
                  <h2 style="margin-top:0;">Security</h2>
                  <div class="wrap" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <ng-container formGroupName="network">
                      
                        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                          <mat-label>Autonomous System Number</mat-label>
                          <input matInput readonly="true" placeholder="Autonomous System Number" formControlName="autonomous_system_number">
                        </mat-form-field>
                    
                    
                      <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                        <mat-label>Autonomous System Organization</mat-label>
                        <input matInput readonly="true" placeholder="Autonomous System Organization" formControlName="autonomous_system_organization">
                      </mat-form-field>
                    
                   
                      <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                        <mat-label>Network</mat-label>
                        <input matInput readonly="true" placeholder="Network" formControlName="network">
                      </mat-form-field>
                  
                </ng-container>
                <ng-container formGroupName="security">
                  
                    <mat-form-field  fxFlex="auto" appearance="outline" [ngClass]="{'errorField': proxyError}">
                      <mat-label>Proxy</mat-label>
                      <mat-select formControlName="proxy" [disabled]="true">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                      </mat-select>
                    </mat-form-field>
                 
                 
                      <mat-form-field fxFlex="auto" appearance="outline" [ngClass]="{'errorField': realyError}">
                        <mat-label>relay</mat-label>
                        <mat-select formControlName="relay" [disabled]="true">
                          <mat-option [value]="true">Yes</mat-option>
                          <mat-option [value]="false">No</mat-option>
                        </mat-select>
                      </mat-form-field>
               
                  
                    <mat-form-field fxFlex="auto" appearance="outline" [ngClass]="{'errorField': torError}">
                      <mat-label>tor</mat-label>
                      <mat-select formControlName="tor" [disabled]="true">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                      </mat-select>
                    </mat-form-field>
               
                  
                    <mat-form-field fxFlex="auto" appearance="outline" [ngClass]="{'errorField': vpnError}">
                      <mat-label>vpn</mat-label>
                      <mat-select formControlName="vpn" [disabled]="true">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                      </mat-select>
                    </mat-form-field>
                 
                </ng-container>
                  </div>
                 
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Form Submission</mat-label>
                      <input matInput readonly="true" placeholder="Form Submission" formControlName="formSubmission">
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Email Count</mat-label>
                      <input matInput readonly="true" placeholder="Email Count" formControlName="emailCount">
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Phone Count</mat-label>
                      <input matInput readonly="true" placeholder="Phone Count" formControlName="phoneCount">
                    </mat-form-field>
                    <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                      <mat-label>Ip Count</mat-label>
                      <input matInput readonly="true" placeholder="Ip Count" formControlName="phoneCount">
                    </mat-form-field>
                  </div>
               
               
      
      <div formGroupName="location" style="border:1px solid #ccc; padding:20px; border-radius: 10px; margin-bottom: 20px;">
        <h2 style="margin-top:0;">
          Location
        </h2>
        <div class="wrap" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>City</mat-label>
            <input matInput readonly="true" placeholder="City" formControlName="city">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Continent</mat-label>
            <input matInput readonly="true" placeholder="Continent" formControlName="continent">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Continent Code</mat-label>
            <input matInput readonly="true" placeholder="Continent Code" formControlName="continent_code">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Country</mat-label>
            <input matInput readonly="true" placeholder="Country" formControlName="country">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Country Code</mat-label>
            <input matInput readonly="true" placeholder="Country Code" formControlName="country_code">
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Is In European Union</mat-label>
            <mat-select formControlName="is_in_european_union" [disabled]="true">
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Latitude</mat-label>
            <input matInput readonly="true" placeholder="Latitude" formControlName="latitude">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Longitude</mat-label>
            <input matInput readonly="true" placeholder="Longitude" formControlName="longitude">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>locale Code</mat-label>
            <input matInput readonly="true" placeholder="Locale Code" formControlName="locale_code">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
              <mat-label>Metro Code</mat-label>
              <input matInput readonly="true" placeholder="Metro Code" formControlName="metro_code">
          </mat-form-field>
          <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
            <mat-label>Region</mat-label>
            <input matInput readonly="true" placeholder="region" formControlName="region">
            </mat-form-field>
            <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
              <mat-label>Region Code</mat-label>
              <input matInput readonly="true" placeholder="Region Code" formControlName="region_code">
              </mat-form-field>
              <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
                <mat-label>Time Zone</mat-label>
                <input matInput readonly="true" placeholder="Time Zone" formControlName="time_zone">
              </mat-form-field>
        </div>
      </div>
      <div class="wrap" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Device Type</mat-label>
          <input matInput readonly="true" placeholder="Device Type" formControlName="deviceType">
          <mat-error
            *ngIf="securityForm.controls['deviceType'].touched && securityForm.controls['deviceType'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Device Id</mat-label>
          <input matInput readonly="true" placeholder="Device Id" formControlName="deviceId">
          <mat-error
            *ngIf="securityForm.controls['deviceId'].touched && securityForm.controls['deviceId'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Mobile</mat-label>
          <input readonly="true" matInput placeholder="Mobile" formControlName="mobile">
          <mat-error
            *ngIf="securityForm.controls['mobile'].touched && securityForm.controls['mobile'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Phone Status</mat-label>
          <input readonly="true" matInput placeholder="Phone Status" formControlName="phoneStatus">
          <mat-error
            *ngIf="securityForm.controls['phoneStatus'].touched && securityForm.controls['phoneStatus'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Email Status</mat-label>
          <input readonly="true" matInput placeholder="Email Status" formControlName="emailStatus">
          <mat-error
            *ngIf="securityForm.controls['emailStatus'].touched && securityForm.controls['emailStatus'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Verified Name</mat-label>
          <input readonly="true" matInput placeholder="Verified Name" formControlName="verifiedName">
          <mat-error
            *ngIf="securityForm.controls['verifiedName'].touched && securityForm.controls['verifiedName'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>National Dnc</mat-label>
          <input readonly="true" matInput placeholder="National Dnc" formControlName="nationalDnc">
          <mat-error
            *ngIf="securityForm.controls['nationalDnc'].touched && securityForm.controls['nationalDnc'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>State Dnc</mat-label>
          <input readonly="true" matInput placeholder="State Dnc" formControlName="stateDnc">
          <mat-error
            *ngIf="securityForm.controls['stateDnc'].touched && securityForm.controls['stateDnc'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Dma</mat-label>
          <input readonly="true" matInput placeholder="Dma" formControlName="dma">
          <mat-error
            *ngIf="securityForm.controls['dma'].touched && securityForm.controls['dma'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field class="disabled" fxFlex="auto" appearance="outline">
          <mat-label>Dnc Litigator</mat-label>
          <input readonly="true" matInput placeholder="Dnc Litigator" formControlName="dncLitigator">
          <mat-error
            *ngIf="securityForm.controls['dncLitigator'].touched && securityForm.controls['dncLitigator'].hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
      </div>

                
     
              </form>
            </fury-card-content>
          </fury-card>


         
        </div>
        <div *ngIf="paramName == 'flags'">
          <ul>
           <li *ngFor="let item of leadDetails?.leadError">{{item}}</li>
          </ul>
          <p *ngIf="!leadDetails?.leadError">No Errors Found</p>
         </div>
         <div *ngIf="paramName == 'paymentInformation'">
          <fury-card [@fadeInUp]>
            <fury-card-content>
              <form [formGroup]="paymentInfoForm">
              <div class="content" fxLayout="column" fxLayoutGap="8px">
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Transaction Id</mat-label>
                   <input matInput type="text" formControlName="transactionId" readonly>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Transaction Price</mat-label>
                   <input matInput type="text" formControlName="amount" readonly>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Card Type</mat-label>
                   <input matInput type="text" placeholder="Card Type" formControlName="cardType" readonly>
                  </mat-form-field>
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Card LastFour Digit</mat-label>
                   <input matInput type="text" placeholder="Card LastFour Digit" formControlName="cardLastFourDigit" readonly>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Created At</mat-label>
                   <input matInput type="date" formControlName="createdAt" readonly>
                  </mat-form-field>
                </div>
                </div>
              </form>
            </fury-card-content>
          </fury-card>
        </div>
      </div>
    </fury-page-layout-content>
  
  </fury-page-layout>